export default "__VITE_ASSET__DsnWvjji__"